import { createColumnHelper } from "@tanstack/react-table";
import dayjs from "dayjs";
import { Button } from "react-bootstrap";
import DataTable from "../../../components/dataTable/DataTable";
import RegistrosRondaColaboradoresContagem from "./RegistrosRondaColaboradorContagem";
import RegistrosRondaDiasContagem from "./RegistrosRondaDiasContagem";
import RegistrosRondaQrcodeContagem from "./RegistrosRondaQrcodeContagem";
import QrCodeRondaLocaisSelecionado from "./RondaLocaisSelecionados";
import styles from "./styles.module.css";

export default function QrCodeRondaMapaPainelLateral({ registrosRonda, filtroDados, setShowModalConsultar }:iProps) {
    return (
        <div id={styles.painel_lateral}>
            <h1 id="titleMain">Visualizar Registros Ronda</h1>
            <br></br>
            <div className="div-row" style={{ justifyContent: "space-between" }}>
                <QrCodeRondaLocaisSelecionado registros={registrosRonda} filtros={filtroDados} />
                <div>
                    <Button
                        onClick={() => {
                            setShowModalConsultar(true);
                        }}
                        variant="primary"
                        style={{ height: "40px", minWidth: "175px" }}
                        className="div-row-space-between"
                    >
                        Consultar Ronda <span className="material-symbols-outlined">search</span>
                    </Button>
                </div>
            </div>
            <br></br>
            <RegistrosRondaDiasContagem registros={registrosRonda} filtro={filtroDados} />
            <RegistrosRondaQrcodeContagem registros={registrosRonda} filtro={filtroDados} />
            <RegistrosRondaColaboradoresContagem registros={registrosRonda} filtro={filtroDados} />
            <div id={styles.div_registros}>
                <DataTable dados={registrosRonda} tableSize={"auto"} defaultColumns={defaultColumns} tableMiddleClickhandler={() => {}} tableClickhandler={() => {}} defaultOrder={defaultOrder} defaultRows={23} />
            </div>
        </div>
    );
}
interface iProps { 
    registrosRonda: any[]
    filtroDados: any
    setShowModalConsultar: any
}

const columnHelper = createColumnHelper<any>();
const defaultColumns = [
    columnHelper.accessor((row) => `${dayjs(row.data_criacao).format("DD/MM/YYYY HH:mm:ss")} #${row.id_scan}`, {
        header: "Registro em",
        size: 300,
    }),
    columnHelper.accessor((row) => `#${row.matricula} | ${row.nome_completo}`, {
        header: "Colaborador",
        size: 500,
    }),
    columnHelper.accessor((row) => `#${row.id_qrcode} | ${row.descricao}`, {
        header: "QRCode",
        size: 500,
    }),
    columnHelper.accessor((row) => `${row.internet} ${row.conexao} - ${row.modo_registro === "camera" ? "Scanner QRCODE" : "NFC TAG"}`, {
        header: "Conexão",
        size: 300,
    }),
    columnHelper.accessor((row) => (row.latitude !== null ? `${row.latitude}, ${row.longitude}` : "Não disponível"), {
        header: "Lat/Long",
        size: 300,
    }),
    columnHelper.accessor((row) => row.obs, {
        header: "Observação",
        size: 300,
    }),
];
const defaultOrder: any[] = [];
